
import React from 'react';
import { Button } from 'wbm-inputs';

type ViewCartProps = {
    viewCartUrl: string
}

export const ViewCart = ({ ...props }: ViewCartProps) => {
    return (
        <a href={props.viewCartUrl} className="wbm-button btn-link">
            <Button className="btn-outline-primary medium">VIEW CART</Button>
        </a>
    );
}
